module.exports = __webpack_public_path__ + "static/img/2.963cf73.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/2.png
// module id = /JNB
// module chunks = 1